import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['muteButton', 'unmuteButton', 'buttonContainer'];
  static values = {
    muteUrl: String,
    unmuteUrl: String,
  };

  async triggerMute() {
    const targetButton = this.muteButtonTarget;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';
    targetButton.classList.add('opacity-50');

    const response = await fetch(this.muteUrlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
    });

    await response.json();

    if (!response.ok) {
      this.showErrorTooltip(targetButton);
    } else {
      targetButton.classList.remove('opacity-50');
      this.buttonContainerTarget.classList.add('action-button-slide-up');
    }
  }

  async triggerUnmute() {
    const targetButton = this.unmuteButtonTarget;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';
    targetButton.classList.add('opacity-50');

    const response = await fetch(this.unmuteUrlValue, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
    });

    await response.json();

    if (!response.ok) {
      this.showErrorTooltip(targetButton);
    } else {
      targetButton.classList.remove('opacity-50');
      this.buttonContainerTarget.classList.remove('action-button-slide-up');
    }
  }

  showErrorTooltip(target) {
    const tooltip = new bootstrap.Tooltip(target, {
      trigger: 'manual',
      placement: 'bottom',
    });

    tooltip.show();

    setTimeout(() => tooltip.dispose(), 3000);
  }
}
